import { trialStateAdapter } from 'self-service-api/adapters/trialStateAdapter';
import { TrialsApi } from 'self-service-api/core/api/trialApi';
const getTrialState = () => TrialsApi.getTrialState().then(trialState => trialStateAdapter(trialState));
export default getTrialState;